var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 879,
    height: 879,
    viewBox: "0 0 879 879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.067 366.245C238.067 254.997 328.256 164.808 439.505 164.808C550.753 164.808 640.942 254.997 640.942 366.245C640.942 477.494 550.753 567.683 439.505 567.683C328.256 567.683 238.067 477.494 238.067 366.245Z",
    fill: "url(#paint0_linear_64_28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.692 629.78C665.261 582.223 732.505 482.09 732.505 366.245C732.505 204.418 601.332 73.2451 439.505 73.2451C277.696 73.2451 146.505 204.418 146.505 366.245C146.505 482.108 213.748 582.259 311.336 629.799V787.433C311.335 790.748 312.235 794.001 313.938 796.845C315.642 799.69 318.086 802.018 321.009 803.582C323.932 805.146 327.225 805.887 330.537 805.726C333.848 805.565 337.054 804.509 339.812 802.669L439.505 736.194L539.216 802.669C541.974 804.509 545.18 805.565 548.491 805.726C551.803 805.887 555.096 805.146 558.019 803.582C560.942 802.018 563.386 799.69 565.09 796.845C566.793 794.001 567.693 790.748 567.692 787.433V629.78ZM439.505 622.62C581.097 622.62 695.88 507.837 695.88 366.245C695.88 224.653 581.097 109.87 439.505 109.87C297.913 109.87 183.13 224.653 183.13 366.245C183.13 507.837 297.913 622.62 439.505 622.62Z",
    fill: "url(#paint1_linear_64_28)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_28",
    x1: 127.903,
    y1: 147.184,
    x2: 371.101,
    y2: 451.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD722D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopColor: "#BD7431",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6E28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_28",
    x1: -13.7339,
    y1: 41.2027,
    x2: 439.5,
    y2: 494.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD722D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopColor: "#BD7431",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6E28"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.260bc39a8d458fe084e738c6467d5ab3.svg";
export { ForwardRef as ReactComponent };